import React from 'react';
import { connect } from 'react-redux';
import Today from '../components/Today/Today';
import { filter } from 'lodash';
import moment from 'moment';
import { saveTask } from '../store/modules/task';

const mapActionCreators = {
  saveTask,
};

// const today = moment();

const mapStateToProps = (state, { today }) => ({
  tasks: filter(state.task.tasks, el => {
    if (typeof el === 'undefined') {
      return false;
    }

    if (el.deleted_at !== null) {
      return false;
    }

    if (
      el.assignee_id !== state.login.staff.id &&
      el.done_by !== state.login.staff.id
    ) {
      // not my task
      return false;
    }

    if (el.done_at !== null) {
      const doneAt = moment(el.done_at);

      if (today.isSame(doneAt, 'day')) {
        // was done today
        return true;
      } else {
        // is done but not today, don't show it
        return false;
      }
    }

    if (el.due_date !== null) {
      const dueAt = moment(el.due_date);

      // if (today.isSameOrAfter(dueAt, 'day')) {
      // is due today or in the past
      if (el.is_done === false) {
        // not done, show all
        return true;
      } else if (today.diff(dueAt, 'days') === 0) {
        // done, show only those ending today
        return true;
      }
      // }
    } else {
      return true;
    }

    return false;
  }),
  activities: filter(state.activity.activities, el => {
    if (el.deleted_at !== null) {
      return false;
    }

    if (el.start_time !== null) {
      const startAt = moment(el.start_time);

      if (today.isSame(startAt, 'day')) {
        return true;
      }
    }

    if (el.end_time !== null) {
      const endAt = moment(el.end_time);

      if (today.isSame(endAt, 'day')) {
        return true;
      }
    }

    return false;
  }),
  staff: _.filter(
    _.pick(state.staff.staffs, state.staff.birthdays[today.format('DD.MM')]),
    ['deleted_at', null],
  ),
  persons: _.filter(
    _.pick(state.person.persons, state.person.birthdays[today.format('DD.MM')]),
    ['deleted_at', null],
  ),
});

export default connect(mapStateToProps, mapActionCreators)(Today);



// WEBPACK FOOTER //
// ./src/containers/Today.js